import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Modal, DatePicker, TreeSelect, Card, Tabs, Button, Row, Col, Alert, Space, Divider, Table, Tag } from 'antd';
import { ReloadOutlined, EditOutlined, UserSwitchOutlined, DownloadOutlined, SwapOutlined, ExportOutlined, EyeOutlined } from '@ant-design/icons';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _, { } from 'lodash';
import qs from 'qs';
import { Form } from '@ant-design/compatible';
import CustomerScheduleDetail from './CustomerScheduleDetail';
import CustomerScheduleForm from './CustomerScheduleForm';
import CustomerScheduleUpdateStatusForm from './CustomerScheduleUpdateStatusForm';
import { checkPermission } from '@/utils/permission';
import { cleanObject, makeTree, isValidDate, CustomerScheduleType, CustomerScheduleNaStatus, CustomerScheduleStatus, CustomerScheduleTeleStatus, formatNumber, ConvertCustomerScheduleType, ConvertCustomerScheduleStatus } from '@/utils/helpers';
import HtmlParser from 'react-html-parser';
import BaseSelect from '@/components/Elements/BaseSelect';
import { isMobile } from 'react-device-detect';
import html2canvas from 'html2canvas';
import moment from 'moment';
import { getListCustomerSchedule2, exportExcel, transferToStaff, getSpecificCustomerSchedule, removeCustomerSchedule, changeSchedule } from '@/redux/actions/CustomerScheduleActions';
import { getSpecificCustomer } from '@/redux/actions/customerActions';
import DynamicTable from '@/components/DynamicTable';
import FilterableMultiSelect from '@/components/FilterableMultiSelect';
import PhoneNumberList from '@/components/PhoneNumberList';
import { NotificationManager } from 'react-notifications';
import { Helmet } from 'react-helmet';
import CustomerInfoColumn from '@/components/customers/CustomerInfoColumn';
import ScheduleStatusButton from '@/components/ScheduleStatusButton';
import ScheduleTimeCell from '@/components/ScheduleTimeCell';
import TelesaleFollowUpAssignForm from '@/components/TelesaleFollowUpAssignForm';
import { fetchFilters } from '@/redux/actions/filterActions';

const { confirm } = Modal;
const { RangePicker } = DatePicker;

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/customer-schedule',
        breadcrumbName: 'Lịch hẹn',
    },
]
const { TabPane } = Tabs;
class CustomerScheduleList2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedRowKeys: [],
            selectedRows: [],
            isOpenForm: false,
            currentItem: null,
            isOpenDetail: false,
            currentData: null,
            isOpenStatusForm: false,
            loadingChangeSchedule: false,
            loadingCapture: false,
            isTelesaleAssignOpen: false,
            isLoadingExport: false,
            currentCustomer: null,
            currentTime: moment(),
            pendingChangeSchedulePayload: null
        }

        this.tableRef = createRef();
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.loadData(query);
        this.props.fetchFilters();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.loadData(query);
        }
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        if (name === 'created_at') {
            if (value && value.length > 0) {
                query.created_date_start = moment(value[0]).format('YYYY-MM-DD');
                query.created_date_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.created_date_start;
                delete query.created_date_end;
            }
        }
        if (name === 'appointment_schedule') {
            if (value && value.length > 0) {
                query.appointment_schedule_start = moment(value[0]).format('YYYY-MM-DD');
                query.appointment_schedule_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.appointment_schedule_start;
                delete query.appointment_schedule_end;
            }
        }
        delete query.created_at;
        delete query.appointment_schedule;
        delete query.schedule_consultation;
        query = cleanObject(query);
        //console.log("query: ", query)
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys, selectedRows });
    };

    toggleOpenForm(isOpenForm, currentItem = null) {
        this.setState({ isOpenForm: isOpenForm, currentItem: currentItem });
    }

    onEdit(id, customer_id) {
        this.props.getSpecificCustomerSchedule(id).then(res => {
            console.log('sdberhe', res)
            this.props.getSpecificCustomer(customer_id).then(res => {
                console.log('currentCustomer', res)
                this.setState({ currentCustomer: res });
            });
            this.toggleOpenForm(true, res);
        })
    }

    onRemove() {
        const query = qs.parse(this.props.location.search.slice(1));
        this.props.removeCustomerSchedule(this.state.selectedRowKeys).then(() => {
            this.setState({ selectedRowKeys: [] });
            setTimeout(() => {
                Modal.destroyAll();
            }, 800);
            this.loadData(query);
        })
    }

    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeCustomerSchedule([id]).then(() => {
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
            }),
            onCancel() { },
        })
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentData: data });
    }

    onDetail(id) {
        this.setState({ current_id: id })
        this.props.getSpecificCustomerSchedule(id).then(res => {
            console.log('sdberhe', res)
            //console.log(res)
            this.toggleOpenDetail(true, res);
        })
    }

    loadData(query) {
        this.setState({ isLoading: true });
        this.props.getListCustomerSchedule2(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    toggleOpenUpdateStatusForm(id, isOpenStatusForm) {
        this.props.getSpecificCustomerSchedule(id).then(res => {
            this.setState({ isOpenStatusForm: isOpenStatusForm, currentItem: res });
        })
    }

    onCancel() {
        this.props.form.resetFields();
        this.setState({
            selectedRowKeys: [],
            selectedRows: [],
            isOpenStatusForm: false,
            visible_change_schedule: false,
            loadingChangeSchedule: false,
            isTelesaleAssignOpen: false,
        })
    }

    handleCaptureClick = async () => {
        this.setState({ loadingCapture: true });

        const table = this.tableRef.current;
        if (!table) return;

        // Tạo một bảng tạm thời với kích thước lớn
        const clonedTable = table.cloneNode(true);
        clonedTable.style.width = 'max-content';
        clonedTable.style.height = 'max-content';

        // Thêm bảng tạm thời vào body để tránh các ràng buộc CSS
        document.body.appendChild(clonedTable);

        // Chụp ảnh của bảng tạm thời
        await html2canvas(clonedTable).then(canvas => {
            // Chuyển canvas thành hình ảnh và tải xuống
            const imgData = canvas.toDataURL('image/jpg');
            const link = document.createElement('a');
            const d = new Date();
            const f = (n) => (`0${n}`).slice(-2);
            link.href = imgData;
            link.download = `lich-hen-${[f(d.getDate()), f(d.getMonth() + 1), d.getFullYear(), f(d.getHours()), f(d.getMinutes())].join('-')}.jpg`;
            link.click();

            // Loại bỏ bảng tạm thời sau khi đã chụp ảnh
            document.body.removeChild(clonedTable);
        });
        this.setState({ loadingCapture: false });
    };


    handleChangeSchedule = (e) => {
        e.preventDefault();

        this.props.form.validateFields(['time', 'name'], async (err, values) => {
            if (err) return;

            const { selectedRowKeys } = this.state;

            const payload = {
                ...values,
                time: values.time ? values.time.format('YYYY-MM-DD HH:mm') : null,
                schedule_ids: selectedRowKeys
            };

            this.setState({ loadingChangeSchedule: true });

            try {
                const res = await this.props.changeSchedule(payload);
                // THÀNH CÔNG → SHOW MODAL KẾT QUẢ
                this.showTransferResultModal({
                    transferred: res?.transferred || [],
                    conflicted: res?.conflicted || [],
                });

            } catch (error) {
                this.setState({ loadingChangeSchedule: false });
                console.error('Change schedule error:', error);
            } finally {
                this.setState({ loadingChangeSchedule: false });
            }
        });
    };

    showTransferResultModal = ({ transferred = [], conflicted = [] }) => {
        Modal.info({
            title: 'Kết quả chuyển lịch',
            width: isMobile ? '100%' : 700,
            bodyStyle: { padding: 15 },
            className: 'confirm-modal',
            okText: 'Đóng',

            content: (
                <div>
                    {/* ===== LỊCH ĐÃ CHUYỂN ===== */}
                    <Alert
                        type="success"
                        showIcon
                        className="mb-2"
                        message={`Đã chuyển thành công ${transferred.length} lịch`}
                    />

                    {transferred.length > 0 && (
                        this.renderTransferredTable(transferred)
                    )}

                    {/* ===== LỊCH BỊ TRÙNG ===== */}
                    {conflicted.length > 0 && (
                        <div className='mt-4'>
                            <Alert
                                type="warning"
                                showIcon
                                className="mb-2"
                                message={`Có ${conflicted.length} lịch bị trùng, không chuyển nhưng đã cập nhật trạng thái là đã chuyển lịch.`}
                            />
                            {this.renderConflictedTable(conflicted)}
                        </div>
                    )}
                </div>
            ),

            onOk: () => {
                // Sau khi user xem xong mới reload
                const query = qs.parse(this.props.location.search.slice(1));
                this.loadData(query);
                this.onCancel();
            }
        });
    };

    renderTransferredTable = (data) => (
        <Table
            size="small"
            rowKey="id"
            pagination={false}
            columns={[
                {
                    title: 'Khách hàng',
                    dataIndex: 'customer_name',
                    width: 250
                },
                {
                    title: 'Thời gian mới',
                    dataIndex: 'time',
                    render: t => moment(t).format('DD/MM/YYYY HH:mm'),
                },
                {
                    title: 'Cơ sở',
                    dataIndex: 'branch_name',
                },
                {
                    title: 'Trạng thái',
                    dataIndex: 'status',
                    render: () => <Tag color="green">Đã chuyển</Tag>,
                },
            ]}
            dataSource={data}
        />
    );

    renderConflictedTable = (data) => (
        <Table
            size="small"
            rowKey="id"
            pagination={false}
            columns={[
                {
                    title: 'Khách hàng',
                    dataIndex: 'customer_name',
                    width: 250
                },
                {
                    title: 'Thời gian',
                    dataIndex: 'time',
                    render: t => moment(t).format('DD/MM/YYYY HH:mm'),
                },
                {
                    title: 'Cơ sở',
                    dataIndex: 'branch_name',
                },
                {
                    title: 'Trạng thái',
                    dataIndex: 'status',
                    render: () => <Tag color="orange">Trùng lịch</Tag>,
                },
            ]}
            dataSource={data}
        />
    );

    changeName(value) {
        if (value == 'CHUADATDUOCLICH' || value == 'CHUAXACDINHLICH') {
            this.setState({ require_time: false })
            this.props.form.setFieldsValue({ time: null })
        } else {
            this.setState({ require_time: true })
        }
    }

    startExcelExport() {
        const { auth } = this.props;

        const query = qs.parse(this.props.location.search.slice(1));

        this.setState({ isLoadingExport: true });

        // Gọi API exportExcel, nhưng không chờ response
        this.props.exportExcel(query).catch(() => {
            NotificationManager.error(
                "Có lỗi xảy ra trong quá trình gửi yêu cầu xuất file. Vui lòng thử lại sau.",
                "Lỗi",
                9000
            );
        }).finally(() => {
            this.setState({ isLoadingExport: false });
        });

        this.setState({ isLoadingExport: false });
        // Thông báo ngay lập tức cho người dùng
        NotificationManager.success(
            `Quá trình xuất file đang được thực hiện. 
        File kết quả sẽ được gửi vào email ${auth.user_email} trong ít phút.`,
            "Thông báo",
            9000
        );
    }

    render() {
        var { schedule_list, pagination, users, doctors, statistics, filterData } = this.props;
        var { isLoading, selectedRowKeys,
            isOpenForm,
            currentItem, isOpenDetail,
            currentData, current_id,
            isOpenStatusForm,
            visible_change_schedule,
            loadingChangeSchedule,
            selectedRows,
            require_time,
            currentCustomer,
            loadingCapture,
            isLoadingExport,
            isTelesaleAssignOpen
        } = this.state;

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };

        const hasSelected = selectedRowKeys.length > 0;
        const { getFieldDecorator } = this.props.form;
        var query = qs.parse(this.props.location.search.slice(1));


        const customerIds = selectedRows.map(item => item.customer_id);

        // Helmet được chèn vào đây
        const pageTitle = 'LỊCH HẸN - CHINGO DENTAL';

        const customer_source_active_list = filterData?.sources;
        const branchActiveList = filterData?.branches;
        const service_active_list = filterData?.services;

        const service = makeTree(service_active_list || [], 0);

        const getNonEmptyNames = (items, getName) => (
            (items || [])
                .map(getName)
                .filter(Boolean)
        );

        const normalizeTreatmentSessions = (treatmentSessions) => {
            if (!treatmentSessions) return [];
            return Array.isArray(treatmentSessions) ? treatmentSessions : [treatmentSessions];
        };

        const treatmentStyles = {
            wrapper: {
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                lineHeight: 1.5,
                fontSize: 14,
                color: '#262626',
            },
            session: {
                padding: '6px 0',
                borderBottom: '1px solid #f0f0f0',
            },
            doctorRole: {
                color: '#999',
                fontSize: 14,
            },
            doctorName: {
                fontSize: 14,
                fontWeight: 700,
            },
            summaryLine: {
                marginTop: 5,
            },
            summaryLabel: {
                color: '#595959',
                fontWeight: 600,
                fontSize: 14,
                marginRight: 4,
            },
            summaryText: {
                color: '#262626',
                fontSize: 14,
            },
            tags: {
                display: 'inline-flex',
                flexWrap: 'wrap',
                gap: 4,
                verticalAlign: 'top',
            },
            itemTag: {
                margin: 0,
                whiteSpace: 'normal',
                lineHeight: 1.45,
                fontSize: 13,
                border: 0
            },
            empty: {
                color: '#bfbfbf',
                fontSize: 14,
            },
        };

        const renderTreatmentDoctor = (doctor) => {
            if (!doctor?.full_name) return <span style={treatmentStyles.empty}>----</span>;

            const roleName = doctor.user_rolename || doctor.user_role?.name || '';

            return (
                <div>
                    {roleName && (
                        <span style={treatmentStyles.doctorRole}>
                            {roleName} -{' '}
                        </span>
                    )}
                    <span style={treatmentStyles.doctorName}>{doctor.full_name}</span>
                </div>
            );
        };

        const renderCompactLine = (label, items) => (
            items.length ? (
                <div style={treatmentStyles.summaryLine}>
                    <span style={treatmentStyles.summaryLabel}>{items.length} {label}:</span>
                    <span style={treatmentStyles.tags}>
                        {items.map((item, index) => (
                            <Tag key={`${item}-${index}`} color="blue" style={treatmentStyles.itemTag}>
                                {item}
                            </Tag>
                        ))}
                    </span>
                </div>
            ) : null
        );

        const renderTextLine = (label, value) => (
            value ? (
                <div style={treatmentStyles.summaryLine}>
                    <span style={treatmentStyles.summaryLabel}>{label}:</span>
                    <span style={treatmentStyles.summaryText}>{value}</span>
                </div>
            ) : null
        );

        const renderTreatmentTicket = (record) => {
            const treatmentSessions = normalizeTreatmentSessions(
                record?.treatment_sessions || record?.treatmentSessions
            );

            if (!treatmentSessions.length) {
                return <span style={treatmentStyles.empty}>----</span>;
            }

            return (
                <div style={treatmentStyles.wrapper}>
                    {treatmentSessions.map((session, index) => {
                        const procedures = getNonEmptyNames(
                            session?.procedures,
                            (procedure) => procedure?.name
                        );
                        const services = getNonEmptyNames(
                            session?.customer_services || session?.customerServices,
                            (item) => item?.customer_service?.service?.name || item?.customerService?.service?.name
                        );
                        const note = session?.ghi_chu_noi_bo;
                        const treatmentDate = isValidDate(session?.ngay, false);
                        const hasContent = treatmentDate || note || session?.doctor?.full_name || procedures.length || services.length;

                        return (
                            <div
                                key={session?.id || index}
                                style={{
                                    ...treatmentStyles.session,
                                    borderBottom: index === treatmentSessions.length - 1 ? 0 : treatmentStyles.session.borderBottom,
                                }}
                            >
                                {hasContent ? (
                                    <>
                                        {renderTextLine('Ngày điều trị', treatmentDate)}
                                        {session?.doctor?.full_name && renderTreatmentDoctor(session?.doctor)}
                                        {renderCompactLine('thủ thuật', procedures)}
                                        {renderCompactLine('dịch vụ', services)}
                                        {note && (
                                            <div style={treatmentStyles.summaryLine}>
                                                <span style={treatmentStyles.summaryLabel}>Ghi chú:</span>
                                                <span style={treatmentStyles.summaryText}>{HtmlParser(note)}</span>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <span style={treatmentStyles.empty}>----</span>
                                )}
                            </div>
                        );
                    })}
                </div>
            );
        };

        const columns = [
            {
                title: 'STT',
                align: 'center',
                width: '50px',
                dataIndex: 'stt',
                key: 'stt',
                render: (text, record, index) => {
                    return index + 1;
                    //return record.id
                }
            },
            {
                title: 'Giờ',
                dataIndex: 'time_to',
                key: 'time_to',
                width: '180px',
                render: (_, record) => (
                    <ScheduleTimeCell record={record} />
                )
            },
            {
                title: 'Khách hàng',
                key: 'customer',
                width: 300,
                render: (_, record) => {
                    const customer = {
                        id: record?.customer?.id,
                        code: record?.customer?.code,
                        full_name: record?.customer?.full_name,
                        branch_name: record?.customer?.branche?.name,
                        conditions: record?.customer?.conditions,
                        customer_source: record?.customer?.customer_source?.name,
                        customer_status: record?.customer?.customer_status?.name,
                        customer_status_color: record?.customer?.customer_status?.text_color,
                        medical_book_number: record?.customer?.medical_book_number
                    }
                    return (
                        <CustomerInfoColumn
                            record={customer}
                            nameField="full_name"
                            idField="id"
                            codeField="code"
                            branchField="branch_name"
                            medicalBookField="medical_book_number"
                            conditionField="conditions"
                            enableLink={true}
                            sourceField="customer_source"
                        />
                    )
                }
            },
            {
                title: 'Điện thoại',
                dataIndex: 'phone',
                width: '120px',
                key: 'phone',
                render: (text, record) => {
                    return (
                        <PhoneNumberList phones={record.phones} relatedPhones={record.family_relationships} />
                    )
                }
            },
            {
                title: 'Ngày sinh',
                dataIndex: 'customer_birthday',
                key: 'customer_birthday',
                width: 120,
                render: (text, record) => {
                    if (!text) return <span style={{ color: '#bfbfbf' }}>—</span>;

                    const birthDate = moment(text);
                    const isValid = birthDate.isValid();
                    if (!isValid) return <span style={{ color: '#bfbfbf' }}>—</span>;

                    const age = record.customer_age;
                    const formattedDate = isValidDate(record.customer_birthday, false);

                    return (
                        <div style={{ lineHeight: 1.3 }}>
                            <div style={{ fontWeight: 500, color: '#222' }}>
                                {formattedDate}
                            </div>
                            {age && (
                                <div style={{ fontSize: 14, color: '#8c8c8c', marginTop: 2 }}>
                                    {age} tuổi
                                </div>
                            )}
                        </div>
                    );
                },
            },
            {
                title: 'Phụ trách buổi hẹn',
                dataIndex: 'doctors',
                key: 'doctors',
                width: '250px',
                render: (text, record) => {
                    const doctors = record.doctors || [];
                    const assistants = record.assistants || [];
                    return (
                        <>
                            <div>
                                {doctors.map((staff) => (
                                    <div key={staff.id}>
                                        <span style={{ color: "#999" }}>
                                            {staff.user_role?.name || ""}:{' '}
                                        </span>
                                        <span style={{ fontWeight: 600 }}>
                                            {staff.full_name}
                                        </span>
                                    </div>
                                ))}
                            </div>
                            <div style={{ marginTop: 3 }}>
                                {assistants.map((staff) => (
                                    <div key={staff.id}>
                                        <span style={{ color: "#999" }}>
                                            {staff.user_role?.name || ""}:{' '}
                                        </span>
                                        <span style={{ fontWeight: 600 }}>
                                            {staff.full_name}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </>
                    )
                }
            },
            {
                title: 'Trạng thái',
                dataIndex: 'status',
                key: 'status',
                width: '100px',
                render: (_, record) => (
                    <ScheduleStatusButton
                        record={record}
                        onClick={() => this.toggleOpenUpdateStatusForm(record.id, true)}
                    />
                )
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '250px',
                render: (text, record) => {
                    //return (<ExpandableText text={text} rows={1} />)
                    return (<>{HtmlParser(text)}</>)
                }
            },
            {
                title: 'Phiếu điều trị',
                dataIndex: 'treatment_note',
                key: 'treatment_note',
                width: '350px',
                render: (_, record) => renderTreatmentTicket(record)
            },
            {
                title: 'Actions',
                align: 'center',
                width: '250px',
                dataIndex: 'actions',
                key: 'actions',
                render: (text, record) => {
                    return (
                        <Space>
                            <Button
                                type="primary"
                                size='small'
                                disabled={!checkPermission('customer_schedule', 'detail')}
                                icon={<EyeOutlined />}
                                onClick={() => this.onDetail(record.id, record.customer_id)}
                            >
                                Xem chi tiết
                            </Button>
                            <Button
                                type="primary"
                                size='small'
                                disabled={!checkPermission('customer_schedule', 'update')}
                                icon={<EditOutlined />}
                                onClick={() => this.onEdit(record.id, record.customer_id)}
                            >
                                Sửa
                            </Button>
                        </Space>
                    );
                }
            }

        ];

        const tables = <DynamicTable
            dataSource={schedule_list || []}
            columns={columns}
            isLoading={isLoading}
            pagination={pagination}
            rowSelection={rowSelection}
            ref={this.tableRef}
            moduleKey="customer_schedule2"
            onChangeTable={(pagination, sorter) => this.onChangeTable(pagination, sorter)}
            getRowStyle={(record) => {
                const colorMap = {
                    dangcho: '#aac41a19',       // vàng nhạt
                    dangtrongca: '#188fff2e', // xanh nước biển nhạt
                    daden: '#aac41a19',      // xanh lá nhạt
                    daxong: '#53c41a19',      // xanh lá nhạt
                    dagoi: '#53c41a19',      // xanh lá nhạt
                    dahuy: '#ff7f5023',       // cam nhạt
                    chuaden: '#fff',       // vàng cam nhạt
                };
                return record.status && colorMap[record.status]
                    ? { backgroundColor: colorMap[record.status] }
                    : {};
            }}
            className="no-hover-table"
        />

        return (
            <div>
                <Helmet>
                    <title>{pageTitle}</title>
                </Helmet>
                <PageTitle routes={routes} title="Lịch hẹn" />
                <div>
                    <TableActionBar
                        isShowAddButton={false}
                        isShowDeleteButton={checkPermission('customer_schedule', 'remove')}
                        onAdd={() => this.toggleOpenForm(true)}
                        onDelete={() => this.onRemove()}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        placeholderSearch="Mã, tên, 3 số cuối sđt của khách hàng"
                        activeFilter={
                            query.name ||
                            query.created_date_start ||
                            query.schedule_consultation_start ||
                            query.status ||
                            query.customer_id ||
                            query.branch_id ||
                            query.service_id ||
                            query.sales_staff ||
                            query.created_user_id ||
                            query.doctor_id ||
                            query.customer_source_id ||
                            query.branch_service_id
                        }
                        filters={
                            [
                                <BaseSelect
                                    options={CustomerScheduleType || []}
                                    placeholder="Kiểu lịch hẹn"
                                    defaultValue={query.name ? query.name : null}
                                    onChange={(value) => this.onChangeFilter('name', value)}
                                    className="w-100"
                                />,
                                <BaseSelect
                                    options={branchActiveList || []}
                                    optionValue="id"
                                    optionLabel="name"
                                    placeholder="Chọn cơ sở"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('branch_id', value)}
                                    defaultValue={query.branch_id ? parseInt(query.branch_id) : null}
                                />,
                                <BaseSelect
                                    options={branchActiveList || []}
                                    optionValue="id"
                                    optionLabel="name"
                                    placeholder="Chọn cơ sở thực hiện"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('branch_service_id', value)}
                                    defaultValue={query.branch_service_id ? parseInt(query.branch_service_id) : null}
                                />,
                                <BaseSelect
                                    options={CustomerScheduleStatus.concat(CustomerScheduleTeleStatus).concat(CustomerScheduleNaStatus)}
                                    placeholder="Trạng thái"
                                    className="w-100"
                                    defaultValue={query.status ? query.status : null}
                                    onChange={(value) => this.onChangeFilter('status', value)}
                                />,
                                <TreeSelect
                                    showSearch
                                    className="w-100"
                                    dropdownStyle={{ maxHeight: 450, overflow: 'auto' }}
                                    treeData={service}
                                    treeNodeFilterProp='title'
                                    allowClear
                                    placeholder="Dịch vụ"
                                    treeDefaultExpandAll
                                    defaultValue={query.service_id ? parseInt(query.service_id) : null}
                                    onChange={(value) => this.onChangeFilter('service_id', value)}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Nhân viên chốt"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('sales_staff', value)}
                                    defaultValue={query.sales_staff ? parseInt(query.sales_staff) : null}
                                />,
                                <BaseSelect
                                    options={doctors || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Bác sĩ thực hiện"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('doctor_id', value)}
                                    defaultValue={query.doctor_id ? parseInt(query.doctor_id) : null}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Người tạo"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('created_user_id', value)}
                                    defaultValue={query.created_user_id ? parseInt(query.created_user_id) : null}
                                />,
                                <FilterableMultiSelect
                                    options={customer_source_active_list || []}
                                    placeholder="Nguồn khách hàng"
                                    parameterName='customer_source_id'
                                    optionValue="id"
                                    optionLabel="name"
                                />,
                            ]
                        }
                    >
                        <RangePicker
                            format="DD/MM/YYYY"
                            placeholder={['Từ ngày', 'Đến ngày']}
                            style={{ width: 250 }}
                            onChange={(value) => this.onChangeFilter('appointment_schedule', value)}
                            className='table-button'
                            defaultValue={[
                                query.appointment_schedule_start
                                    ? moment(query.appointment_schedule_start, 'YYYY-MM-DD')
                                    : moment(), // mặc định ngày hiện tại
                                query.appointment_schedule_end
                                    ? moment(query.appointment_schedule_end, 'YYYY-MM-DD')
                                    : moment()  // mặc định ngày hiện tại
                            ]}
                        />
                        <Divider type="vertical" />
                        {
                            checkPermission('telesale_follow_up', 'assign') ? (
                                <Button icon={<UserSwitchOutlined />} className="table-button" type='primary' disabled={!selectedRowKeys.length ? true : false} onClick={() => this.setState({ isTelesaleAssignOpen: true })}>Giao cho telesale</Button>
                            ) : null
                        }
                        {
                            checkPermission('customer_schedule', 'change_schedule') ? (
                                <Button icon={<SwapOutlined />} className="table-button" type='primary' disabled={!selectedRowKeys.length ? true : false} onClick={() => this.setState({ visible_change_schedule: true })}>Chuyển lịch</Button>
                            ) : null
                        }

                        <Button className="table-button" type='primary' icon={<DownloadOutlined />} loading={loadingCapture} onClick={() => this.handleCaptureClick()}>Chụp màn hình</Button>
                        {
                            checkPermission('customer_schedule', 'export') ? (
                                <Button className="table-button" loading={isLoadingExport} type='default' onClick={() => this.startExcelExport()} icon={<ExportOutlined />}>Export</Button>
                            ) : null
                        }
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Refresh</Button>
                    </TableActionBar>
                    {
                        hasSelected ? <Row className="mb-2" align="middle">Đang chọn {selectedRowKeys.length} bản ghi </Row> : ''
                    }
                </div>

                <Row gutter={16} className="mb-2" justify="space-between" style={{ margin: 0 }}>
                    <Card size='small' className="appointment-card w-100">
                        <div className="stats-row">
                            <span className="statistic-label">
                                Tổng số lịch hẹn: <span className="value total">{formatNumber(statistics?.total || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Lịch tư vấn: <span className="value consultant">{formatNumber(statistics?.name?.TUVAN || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Lịch điều trị: <span className="value treatment">{formatNumber(statistics?.name?.LAMDICHVU || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Lịch tái khám: <span className="value recheck">{formatNumber(statistics?.name?.TAIKHAM || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Lịch gọi lại: <span className="value recall">{formatNumber(statistics?.name?.GOILAI || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Hủy lịch: <span className="value danger">{formatNumber(statistics?.status?.dahuy || 0)}</span>
                            </span>
                        </div>

                        <div className="stats-row">
                            <span className="statistic-label">
                                Đã đến: <span className="value arrived">{formatNumber(statistics?.arrived_total || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Chưa đến: <span className="value notarrived">{formatNumber(statistics?.status?.chuaden || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Đang chờ: <span className="value waiting">{formatNumber(statistics?.status?.dangcho || statistics?.status?.daden || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Đang trong ca: <span className="value inprogress">{formatNumber(statistics?.status?.dangtrongca || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Đã xong: <span className="value completed">{formatNumber(statistics?.status?.daxong || 0)}</span>
                            </span>
                            <span className="statistic-label">&nbsp;</span>
                        </div>
                        <Divider style={{ margin: '8px 0' }} />
                        <div className="stats-row" style={{ marginBottom: 0 }}>
                            <span className="statistic-label" style={{ display: 'block' }}>
                                Bác sĩ đang trong ca ({statistics?.doctor_in_progress_total || 0}): <span className="doctor_inprogress">{statistics?.doctor_in_progress || ''}</span>
                            </span>
                            <span className="statistic-label" style={{ display: 'block' }}>
                                Bác sĩ ngoài ca ({statistics?.doctor_available_total || 0}): <span className="doctor_available">{statistics?.doctor_available || ''}</span>
                            </span>
                        </div>
                    </Card>
                </Row>

                <Card size='small' bodyStyle={{ padding: 0 }} className='has-custom-column-table-btn'>
                    <Tabs onChange={(value) => this.onChangeFilter('tab', value)} defaultActiveKey={query.tab} type="card" size="small">
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch hẹn hôm nay</span>} key="1">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch hẹn ngày mai</span>} key="2">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch hẹn hôm qua</span>} key="4">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch chưa xác định</span>} key="5">
                            <div ref={this.tableRef}>
                                <Alert
                                    style={{ border: 'none' }}
                                    message="Danh sách các khách hàng chưa hẹn được cụ thể lịch hẹn tiếp theo, cần chú ý liên hệ chăm sóc lại thường xuyên."
                                    type="warning"
                                />
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch chưa đến, chưa gọi</span>} key="6">
                            <div ref={this.tableRef}>
                                <Alert
                                    style={{ border: 'none' }}
                                    message="Danh sách khách hàng đã có lịch hẹn nhưng chưa đến (hoặc chưa gọi lại cho khách), cần gọi lại để hẹn lịch mới hàng ngày."
                                    type="warning"
                                />
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Tất cả lịch hẹn</span>} key="3">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                    </Tabs>
                </Card>

                <CustomerScheduleForm
                    visible={isOpenForm}
                    currentItem={currentItem}
                    currentCustomer={currentCustomer}
                    reloadData={() => this.loadData(query)}
                    onCancel={() => this.toggleOpenForm(false)}
                />
                <CustomerScheduleDetail
                    visible={isOpenDetail}
                    currentItem={currentData}
                    reloadData2={() => this.loadData(query)}
                    reloadData={() => this.onDetail(current_id)}
                    onCancel={() => this.toggleOpenDetail(false)}
                />
                <CustomerScheduleUpdateStatusForm
                    visible={isOpenStatusForm}
                    currentItem={currentItem}
                    reloadData={() => this.loadData(query)}
                    onCancel={() => this.setState({ isOpenStatusForm: false })}
                />
                <TelesaleFollowUpAssignForm
                    visible={isTelesaleAssignOpen}
                    customer_ids={customerIds}
                    onCancel={() => this.onCancel()}
                />

                <Modal
                    title="Chuyển lịch hẹn"
                    visible={visible_change_schedule}
                    header={false}
                    onOk={(e) => this.handleChangeSchedule(e)}
                    width={isMobile ? '100%' : '40%'}
                    onCancel={() => this.onCancel()}
                    maskClosable={false}
                    footer={[
                        <Button key="back" onClick={() => this.onCancel()}>
                            Cancel
                        </Button>,
                        <Button
                            loading={loadingChangeSchedule}
                            key="submit"
                            type="primary"
                            onClick={(e) => this.handleChangeSchedule(e)}
                        >
                            OK
                        </Button>,
                    ]}
                >
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Alert
                                    message="Lưu ý"
                                    type="info"
                                    showIcon
                                    className='mb-5 fix-alert-element'
                                    description={<>
                                        Chỉ chuyển lịch <strong>Điều trị</strong> và lịch <strong>
                                            Tái khám</strong>
                                    </>}
                                />
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label='Lịch hẹn'>
                                    {getFieldDecorator("name", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: null
                                    })(
                                        <BaseSelect
                                            options={CustomerScheduleType}
                                            showSearch
                                            placeholder="Chọn một bản ghi"
                                            style={{ width: '100%' }}
                                            onChange={(value) => this.changeName(value)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            {
                                require_time ? (
                                    <Col xs={24} md={24}>
                                        <Form.Item label="Thời gian">
                                            {getFieldDecorator('time', {
                                                rules: [
                                                    {
                                                        required: require_time,
                                                        message: 'Vui lòng điền!',
                                                    },
                                                ],
                                                initialValue: null
                                            })(
                                                <DatePicker
                                                    style={{ width: '100%' }}
                                                    showTime={{ format: 'HH:mm', defaultValue: moment('00:00', 'HH:mm') }} // Giới hạn giờ và phút là 00:00
                                                    format="DD/MM/YYYY HH:mm"
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                ) : null
                            }
                        </Row>
                    </Form>
                </Modal>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        schedule_list: state.CustomerScheduleReducer.list2.data,
        pagination: state.CustomerScheduleReducer.list2.pagination,
        statistics: state.CustomerScheduleReducer.statistics,
        users: state.config.users,
        auth: state.auth.authUser,
        doctors: state.config.doctors,
        filterData: state.filterReducer.list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListCustomerSchedule2: (filter) => dispatch(getListCustomerSchedule2(filter)),
        getSpecificCustomerSchedule: (id) => dispatch(getSpecificCustomerSchedule(id)),
        removeCustomerSchedule: (ids) => dispatch(removeCustomerSchedule(ids)),
        getSpecificCustomer: (id) => dispatch(getSpecificCustomer(id)),
        transferToStaff: (data) => dispatch(transferToStaff(data)),
        changeSchedule: (data) => dispatch(changeSchedule(data)),
        exportExcel: (filter) => dispatch(exportExcel(filter)),
        fetchFilters: () => dispatch(fetchFilters()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerScheduleList2' })(CustomerScheduleList2));

